import MUIStep from '@mui/material/Step';
import MUIStepButton from '@mui/material/StepButton';
import MUIStepper from '@mui/material/Stepper';
import { palette } from '../../theme/palette';
import { styled } from '@mui/material';

export const RoundStepperRoot = styled(MUIStepper)`
  width: 100%;
  justify-content: center;

  .MuiStep-root {
    padding: 0;
    justify-content: center;
  }

  .MuiStepConnector-root {
    padding: 3px 16px 0 16px;
    max-width: 100px;

    .MuiStepConnector-line {
      border-color: ${palette.custom.extraLightGrey};
      border-top-style: solid;
      border-top-width: 2px;
      border-radius: 100px;
    }

    &.Mui-completed .MuiStepConnector-line {
      border-color: ${palette.custom.mediumGreen};
    }
  }
`;

export const RoundStep = styled(MUIStep)`
  .MuiStepLabel-iconContainer {
    padding-right: 13px;
    .MuiSvgIcon-root {
      color: ${palette.custom.lightGrey};

      &.Mui-completed {
        color: ${palette.custom.mediumGreen};
      }

      .MuiStepIcon-text {
        color: ${palette.custom.mediumGrey};
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0.35px;
        transform: translateY(-1px);
      }

      &.Mui-active {
        color: ${palette.custom.darkGrey};

        .MuiStepIcon-text {
          color: ${palette.custom.white};
          font-style: normal;
          font-weight: 700;
          line-height: 32px;
          letter-spacing: 0.35px;
          transform: translateY(-1px);
        }
      }
    }
  }

  .MuiStepLabel-labelContainer {
    color: ${palette.custom.black};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.35px;
  }
`;

export const RoundStepButton = styled(MUIStepButton)`
  text-transform: capitalize;
`;
